export class Summary {

	totalInvestment: number;
	totalIncome: number;
	grossRescue: number;
	netRescue: number;
	tax: number;
	totalPre: number;
	totalPreValue: number;
	totalPosValue: number;
	totalPrePercent: number;
	totalPrePercentLabel: string;
	totalPreLabel: string;
	totalPosPercent: number;
	totalPosPercentLabel: string;
	totalPosLabel: string;
	totalPos: number;
	total: number;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-extract/models/summary.ts